export class SpecialEventFrequency {
    ID: number;
    Name: string;
}

export default SpecialEventFrequency;